import {animated} from 'react-spring';
import styled, {css} from 'styled-components';

import {TextAreaBox} from '../../../libs/shared/ui/src/components/boxedInputs/textAreaBox';
import {TextBox} from '../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {settingsHorizontalPaddingStyles, settingsHorizontalSpacing} from '../settingsCommonConstants';

/*
 * Constants.
 */

export const SETTINGS_SIDEBAR_WIDTH = 282;
export const SETTINGS_FOOTER_HEIGHT = 62;

interface SettingsStyleProps {
  $disablePadding?: boolean;
}

/*
 * Style.
 */

export const StyledSettingsWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: relative;
`;

export const StyledSettingsMain = styled.div<SettingsStyleProps>`
  flex: 1;
  display: flex;
  ${(p) =>
    !p.$disablePadding &&
    css`
      padding-right: ${settingsHorizontalSpacing}px;
    `}
`;

export const StyledSettingsContent = styled.div`
  flex: 1;
  min-height: min-content;
  display: flex;
  flex-direction: column;
`;

export const StyledSettingsSidebar = styled(animated.div)`
  width: ${SETTINGS_SIDEBAR_WIDTH}px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  overflow: hidden;
`;

export const StyledSettingsContentWrap = styled.div`
  flex: 1;
  margin-bottom: 48px;
  ${settingsHorizontalPaddingStyles};
  display: flex;
  padding-right: 0;
`;

export const SettingsFooter = styled.footer`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${(p) => p.theme.greys.white};

  ${settingsHorizontalPaddingStyles};
  flex-shrink: 0;
  display: grid;
  justify-content: flex-end;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  grid-column-gap: 8px;
  align-items: center;
  height: ${SETTINGS_FOOTER_HEIGHT}px;

  &::before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: ${settingsHorizontalSpacing}px;
    left: ${settingsHorizontalSpacing}px;
    height: 1px;
    background: #e6e6e6;
  }
`;

export const StyledSettingsFormContent = styled.div`
  flex: 1;
  min-height: min-content;

  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  grid-row-gap: 16px;
  margin-top: 7px;
`;

export const StyledSettingsFormMain = styled.div`
  flex: 1;
  padding-bottom: 100px;
  ${settingsHorizontalPaddingStyles};
  display: flex;
  padding-right: 0;
  max-width: 650px;
`;

export const StyledSettingsFormField = styled.div`
  display: flex;
`;

export const StyledSectionedFieldsContainer = styled.div`
  margin-top: 11px;
`;

export const StyledSettingsFormTextBox = styled(TextBox)<{$width: number}>`
  width: ${(p) => p.$width}px;
`;

export const StyledSettingsFormTextAreaBox = styled(TextAreaBox)<{$width: number; $height?: number}>`
  width: ${(p) => p.$width}px;
  ${(p) => p.$height && `height: ${p.$height}px`};
`;

export const StyledSettingsFormHeaderButtons = styled.div`
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  grid-column-gap: 8px;
`;
